<template>
  <div class="set-score-wrap">
    <div class="set-score-header">
      <div class="set-score-target">
        <span class="target-label">{{ setType == 0 ? 'User ID' : $t('msg.User_agent') }}</span>
        <span class="target-id" translate="no">{{ sid }}</span>
      </div>
      <el-tag type="danger" size="small" translate="no">Max {{ coins }}</el-tag>
    </div>

    <div class="set-score-current">
      <div class="current-item">
        <span class="current-label">{{ $t('msg.Current_score') }}</span>
        <span class="current-value" translate="no">{{ userScore }}</span>
      </div>
      <template v-if="setType == 0">
        <div class="current-item">
          <span class="current-label">Winning</span>
          <span class="current-value secondary" translate="no">{{ userWin }}</span>
        </div>
        <div class="current-item">
          <span class="current-label">Deposit</span>
          <span class="current-value secondary" translate="no">{{ userBuy }}</span>
        </div>
      </template>
    </div>

    <el-form :model="fromData" :rules="rules" ref="score" @submit.native.prevent class="set-score-form">
      <el-form-item :label="$t('msg.Set_score2')" prop="score">
        <el-input v-model="fromData.score" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="setScore">{{ $t('msg.OK2') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {GetUserInfo, GetProxyInfo, SetUserScore, SetProxyScore} from "../api";

export default {
  name: "SetScore",
  data() {
    return {
      sid: "",
      setType: 0,
      userScore: 0,
      userWin: 0,
      userBuy: 0,
      fromData: {score: ''},
      rules: {
        score: [
          {required: true, message: this.$t('msg.Please_enter_a_score'), trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              if (isNaN(Number(value, 10))) {
                callback(new Error(this.$t('msg.Score_must_be_numeric')));
              }
              else if (Number(value, 10) == 0) {
                callback(new Error(this.$t('msg.Score_nonzero_hint')));
              }
              else if (value.indexOf(".") != -1 && value.split('.').length > 2) {
                callback(new Error(this.$t('msg.Please_enter_the_correct_score_format'))) //防止输入多个小数点
              } else if (value.indexOf(".") != -1 && value.split('.')[1].length > 3) {
                callback(new Error(this.$t('msg.Enter_up_to_three_decimal_places'))) //小数点后三位
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
      },
      coins: JSON.parse(localStorage.getItem('userInfo')).coins
    }
  },
  methods: {
    getUserInfo() {
      GetUserInfo({"user_id": this.sid}).then((data) => {
        if (data.data.errcode === 0 && data.data.params.status === 0) {
          this.userScore = data.data.params.user.coins
          this.userWin = data.data.params.user.coins_win || 0
          this.userBuy = data.data.params.user.coins_buy || 0
        } else {
          msg = data.data.params.msg
          if (!data.data.params.msg) {
            var msg = this.$t('msg.Failed_to_get_player')
          }
          this.$message({
            message: msg,
            type: 'error',
            offset: 80
          });
        }
      })
    },
    getProxyInfo() {
      GetProxyInfo({"search_username": this.sid}).then((data) => {
        if (data.data.errcode === 0 && data.data.params.status === 0) {
          this.userScore = data.data.params.data.price
        } else {
          msg = data.data.params.msg
          if (!data.data.params.msg) {
            var msg = this.$t('msg.Failed_to_get_agent')
          }
          this.$message({
            message: msg,
            type: 'error',
            offset: 80
          });
        }
      })
    },
    setScore() {
      if (this.fromData.score == 0) {
        return
      }
      var val = true
      var from = 'score'
      this.$refs[from].validate(valid => {
        if (!valid) {
          // 表单验证失败，显示错误消息...
          val = false
        }
      })
      if (val) {
        var proxy_id = localStorage.getItem("proxy_id")
        var timestamp = Date.parse(new Date()) / 1000
        var order_id = proxy_id + '.' + timestamp
        if (parseFloat(this.fromData.score) > 0) {
          order_id += '.1'
        } else {
          order_id += '.0'
        }
        var params = {}

        params["price"] = this.fromData.score
        // 玩家上下分
        if (this.setType == 0) {
          order_id += '.0'
          params["order_id"] = order_id
          params["user_id"] = this.sid
          params["utc-timestamp"] = timestamp
          SetUserScore(params).then((data) => {
            if (data.data.errcode === 0 && data.data.params.status === 0) {
              this.getUserInfo()
              var userInfo = JSON.parse(localStorage.getItem('userInfo'))
              userInfo['coins'] = data.data.params.coins
              localStorage.setItem('userInfo', JSON.stringify(userInfo))
              this.coins = data.data.params.coins
              this.$alert(this.$t('msg.Successful_operation1'), '', {
                confirmButtonText: this.$t('msg.OK2'),
                center: true,
                type: 'success',
                showClose: false,
                customClass:'alert'//添加类名
              })
              this.fromData.score = ''
            } else {
              msg = data.data.params.msg
              if (!data.data.params.msg) {
                var msg = this.$t('msg.Failed_Operation')
              }
              this.$message({
                message: msg,
                type: 'error',
                offset: 80
              });
            }
          })
          // 代理上下分
        } else {
          order_id += '.1'
          params["order_id"] = order_id
          params["search_username"] = this.sid
          params["utc-timestamp"] = timestamp
          SetProxyScore(params).then((data) => {
            if (data.data.errcode === 0 && data.data.params.status === 0) {
              this.getProxyInfo()
              var userInfo = JSON.parse(localStorage.getItem('userInfo'))
              userInfo['coins'] = data.data.params.coins
              localStorage.setItem('userInfo', JSON.stringify(userInfo))
              this.coins = data.data.params.coins
              this.$alert(this.$t('msg.Successful_operation1'), '', {
                confirmButtonText: this.$t('msg.OK2'),
                center: true,
                type: 'success',
                showClose: false,
                customClass:'alert'//添加类名
              })
              this.fromData.score = ''
            } else {
              msg = data.data.params.msg
              if (!data.data.params.msg) {
                var msg = this.$t('msg.Failed_Operation')
              }
              this.$message({
                message: msg,
                type: 'error',
                offset: 80
              });
            }
          })
        }
      }
    }
  },
  mounted() {
    this.sid = this.$route.query.sid
    this.setType = this.$route.query.set_type
    if (this.setType == 0) {
      this.getUserInfo()
    } else {
      this.getProxyInfo()
    }
  }
}
</script>

<style lang="less" scoped>
.set-score-wrap {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .08);
  padding: 24px;
  max-width: 480px;
}

.set-score-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 16px;
  margin-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
}

.set-score-target {
  display: flex;
  align-items: center;
  gap: 8px;

  .target-label {
    color: #909399;
    font-size: 13px;
  }

  .target-id {
    background: #ecf5ff;
    color: #409eff;
    border: 1px solid #d9ecff;
    border-radius: 4px;
    padding: 3px 12px;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 1px;
  }
}

.set-score-current {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  flex-wrap: wrap;
  margin-bottom: 24px;
}

.current-item {
  display: flex;
  flex-direction: column;
  gap: 2px;

  .current-label {
    color: #909399;
    font-size: 12px;
  }

  .current-value {
    color: #f39c12;
    font-size: 22px;
    font-weight: 700;

    &.secondary {
      color: #409eff;
      font-size: 18px;
    }
  }
}

.set-score-form {
  .el-form-item:last-child {
    margin-bottom: 0;
  }
}
</style>

<style lang="less">
@media screen and (max-width: 500px) {
  .alert {
    width: 240px;
  }
  .set-score-wrap {
    padding: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/SetScore.vue